/**
 * Whether Edit's Continue still has to upload the session's individual photos.
 *
 * Select starts the photo upload as soon as the photos are ready, and Edit's Continue uploads them
 * again unless the gallery says Select has done it. Select set that flag only once every upload
 * had returned, and only while Select was still on screen. With Edit enabled the guest has
 * normally left for Edit by then, so the flag never landed and Edit registered every photo a
 * second time under a new key: ARKADIA COFFEE, 2026-10-13..26, 195 of 274 sessions, each copy
 * byte-identical (7mvpzl, 8i48vh, 8ifr72).
 *
 * Select now also records when it started (`individualPhotosUploadStartedAt`). Files it could not
 * register are already in the retry queue or handed to main, so a second pass adds nothing but a
 * duplicate, unless it watermarks the photos: Edit applies the capture watermark, Select does not.
 * That case keeps today's behaviour.
 *
 * Pure so it tests without the renderer.
 */

export interface PhotoUploadMarks {
  /** Set once Select's (or Edit's) photo upload has returned. */
  individualPhotosUploaded?: boolean
  /** Set when Select starts uploading the photos of this session. */
  individualPhotosUploadStartedAt?: number
}

export function editShouldUploadPhotos(gallery: PhotoUploadMarks, addsWatermark: boolean): boolean {
  if (gallery.individualPhotosUploaded) return false
  if (gallery.individualPhotosUploadStartedAt && !addsWatermark) return false
  return true
}
